import React, { useEffect, useRef, useState } from 'react';
import {
    useAssignMentorToWebinarMutation,
    useCreateWebinarMutation,
    useDeleteWebinarMutation,
    useGetAdminWebinarListQuery,
} from '../webinarApiSlice';
import Heading from '../../../components/header';
import _ from 'lodash';
import ViewWebinarContainer from '../../../container/webinarContainer';
import useApiTopLoading from '../../../hooks/useApiTopLoading';
import { useDispatch } from 'react-redux';
import useApiLoadingOverlay from '../../../hooks/useApiLoadingOverlay';
import DeleteConfirm from '../../../container/councellingStudentContainer/features/DeleteConfirm';
import { actionNotifier } from '../../../components/ui/toast';

const ViewWebinarListPage = () => {
    const dispatch = useDispatch();

    /* ---------- table filters ---------- */
    const [filters, setFilters] = useState({
        search: '',
        filters: {},
        sort: { column: 'onDateTime', order: 'desc' },
    });

    const [countPerPage, setCountPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalCount, setTotalCount] = useState('');

    const handlePageChange = (e, page) => {

        setCurrentPage(page)
    };

    /* ---------- search handling ---------- */
    const [search, setSearch] = useState('');
    const debouncedSearch = useRef(
        _.debounce((value) => {
            setFilters((prev) => ({ ...prev, search: value }));
        }, 300),
    ).current;

    useEffect(() => () => debouncedSearch.cancel(), [debouncedSearch]);

    const onSearch = (event) => {
        const value = event.target.value;
        setSearch(value);
        debouncedSearch(value);
    };

    /* ---------- RTK Query hooks ---------- */
    const {
        data,
        isLoading,
        isFetching,
        isError,
    } = useGetAdminWebinarListQuery({
        page: currentPage,
        items: countPerPage,
        filters,
    });

    const [createWebinar, { isLoading: isLoadingCreatingWebinar }] =
        useCreateWebinarMutation();
    const [deleteWebinar, { isLoading: isLoadingDeleteWebinar }] =
        useDeleteWebinarMutation();
    const [
        assignMentorToWebinar,
        { isLoading: isLoadingAssignMentorToWebinar },
    ] = useAssignMentorToWebinarMutation();

    /* ---------- effects ---------- */
    useEffect(() => {
        if (data) setTotalCount(data?.count);
    }, [data]);

    useApiTopLoading([isFetching], dispatch);
    useApiLoadingOverlay(
        [isLoadingCreatingWebinar, isLoadingAssignMentorToWebinar, isLoading, isLoadingDeleteWebinar],
        dispatch,
    );

    /* ---------- delete‑confirm modal state (assumed) ---------- */
    const [deleteModal, setDeleteModal] = useState(false);

    const [assignData, setAssignData] = useState([])

    const handleDeleteWebinar = async () => {
        if (!assignData || assignData.length === 0) {
            // console.warn("No webinars selected for deletion");
            actionNotifier.info("Select at least one webinar first.");
            setDeleteModal(false)
            return;
        }

        try {
            await deleteWebinar({ data: { webinarIds: assignData } }).unwrap();
            setDeleteModal(false);
            setAssignData([]);
            actionNotifier.success("Webinar(s) deleted successfully");
        } catch (error) {
            console.error("Error deleting webinar:", error);
            actionNotifier.error("Something went wrong while deleting the webinar.");
        }
    };


    /* ---------- render ---------- */
    return (
        <>
            <Heading
                text="Webinar List"
                path="#"
                onSearch={onSearch}
                search={search}
                isFilterShow={false}
                isGraphShow={false}
                setDeleteModal={setDeleteModal}
            />

            <ViewWebinarContainer
                data={data}
                filters={filters}
                setFilters={setFilters}
                total={Math.ceil(totalCount / countPerPage)}
                countPerPage={countPerPage}
                page={currentPage || 1}
                createWebinar={createWebinar}
                role="admin"
                setCurrentPage={setCurrentPage}
                assignMentorToWebinar={assignMentorToWebinar}
                deleteWebinar={deleteWebinar}
                assignData={assignData}
                setAssignData={setAssignData}
                onChange={handlePageChange}
            />

            <DeleteConfirm
                isModalOpen={deleteModal}
                handleModal={handleDeleteWebinar}
                setIsModalOpen={setDeleteModal}
                title="Webinar"
            />
        </>
    );
};

export default ViewWebinarListPage;
